import { ISuccessResponse, sendFeedback } from '../../api/bti/feedback';
import { IServerError } from '../../api/types';
import { IThunkActionCreator } from '../index';

export enum EStatusFetch {
  none,
  ok,
  isLoad,
  error,
}

export interface IBtiDataErrorPopupStoreState {
  error: string;
  isOpen: boolean;
  statusFetch: EStatusFetch;
}

export interface IBtiDataErrorPopupOpen {
  type: 'IBtiDataErrorPopupOpen';
}

export interface IBtiDataErrorPopupClose {
  type: 'IBtiDataErrorPopupClose';
}

export interface IBtiDataErrorPopupFetching {
  payload: {
    statusFetch: EStatusFetch;
  };
  type: 'IBtiDataErrorPopupFetching';
}

export interface IBtiDataErrorPopupFetchingSuccess {
  payload: {
    statusFetch: EStatusFetch;
  };
  type: 'IBtiDataErrorPopupFetchingSuccess';
}

export interface IBtiDataErrorPopupFetchingError {
  payload: {
    message: string;
    statusFetch: EStatusFetch;
  };
  type: 'IBtiDataErrorPopupFetchingError';
}

export function openBtiDataErrorPopup(): IBtiDataErrorPopupOpen {
  return {
    type: 'IBtiDataErrorPopupOpen',
  };
}

export function closeBtiDataErrorPopup(): IBtiDataErrorPopupClose {
  return {
    type: 'IBtiDataErrorPopupClose',
  };
}

export function submitFeedback(host: string, email: string, message: string, url: string): IThunkActionCreator {
  return (dispatch, getState, context) => {
    dispatch({
      payload: {
        error: '',
        statusFetch: EStatusFetch.isLoad,
      },
      type: 'IBtiDataErrorPopupFetching',
    });

    sendFeedback(context.makeRequest, host, email, message, url)
      .then((response: ISuccessResponse) => {
        dispatch({
          payload: {
            statusFetch: EStatusFetch.ok,
          },
          type: 'IBtiDataErrorPopupFetchingSuccess',
        });
      })
      .catch((error: IServerError) => {
        dispatch({
          payload: {
            message: 'Не удалось отправить данные. Попробуйте позже.',
            statusFetch: EStatusFetch.error,
          },
          type: 'IBtiDataErrorPopupFetchingError',
        });
      });
  };
}

export type TBtiDataErrorPopupActions =
  | IBtiDataErrorPopupOpen
  | IBtiDataErrorPopupClose
  | IBtiDataErrorPopupFetching
  | IBtiDataErrorPopupFetchingSuccess
  | IBtiDataErrorPopupFetchingError;

const initialState = {
  error: '',
  isOpen: false,
  statusFetch: EStatusFetch.none,
};

export function BtiDataErrorPopupReducer(
  state: IBtiDataErrorPopupStoreState = initialState,
  action: TBtiDataErrorPopupActions,
): IBtiDataErrorPopupStoreState {
  switch (action.type) {
    case 'IBtiDataErrorPopupOpen':
      return {
        ...state,
        isOpen: true,
      };

    case 'IBtiDataErrorPopupClose':
      return {
        ...state,
        error: '',
        isOpen: false,
        statusFetch: EStatusFetch.none,
      };

    case 'IBtiDataErrorPopupFetching':
      return {
        ...state,
        error: '',
        statusFetch: action.payload.statusFetch,
      };

    case 'IBtiDataErrorPopupFetchingSuccess':
      return {
        ...state,
        error: '',
        statusFetch: action.payload.statusFetch,
      };

    case 'IBtiDataErrorPopupFetchingError':
      return {
        ...state,
        error: action.payload.message,
        statusFetch: action.payload.statusFetch,
      };

    default:
      return state;
  }
}
